const INTERVAL_LABELS = {
  week: 'Weekly',
  month: 'Monthly',
  quarter: 'Quarterly',
  half_year: 'Half-yearly',
  year: 'Annual'
};

const INTERVAL_SHORT = {
  week: 'wk',
  month: 'mo',
  quarter: 'qtr',
  half_year: '6mo',
  year: 'yr'
};

export function formatMoney(amount, currency = 'USD') {
  const n = Number(amount);
  if (Number.isNaN(n)) return '$0.00';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(n);
}

export function formatIntervalLabel(interval) {
  if (!interval) return '';
  return INTERVAL_LABELS[interval] || interval.replace(/_/g, ' ');
}

export function formatIntervalShort(interval) {
  if (!interval) return '';
  return INTERVAL_SHORT[interval] || interval;
}

export function formatPriceChip(price) {
  const amount = formatMoney(price.price, price.currency);
  const suffix = formatIntervalShort(price.interval);
  return `${amount}/${suffix}`;
}

export function summarizePrices(tier) {
  const active = (tier.prices || []).filter((p) => p.isActive !== false);
  if (!active.length) return 'No prices';

  const chips = active
    .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
    .map((p) => formatPriceChip(p));

  return `${active.length} price${active.length === 1 ? '' : 's'} · ${chips.join(' · ')}`;
}

export function monthlyEquivalent(annualPrice) {
  const n = Number(annualPrice);
  if (!n) return null;
  return Math.round((n / 12) * 100) / 100;
}

export function tierIconClass(tier) {
  if (tier === 'free') return 'fa-gift';
  if (tier === 'group') return 'fa-users';
  return 'fa-user-shield';
}

export function tierHeaderClass(tier) {
  return tier || 'single';
}
